import Credentials from './Credentials';

class LoginUtility{
    static login(credentials){
        throw new Error("Method must be implemented");
    }
}

export default LoginUtility